import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/manufacturers/profile/loading';

export const Route = createFileRoute('/_private/settings/manufacturers/$id')({
  pendingComponent: Loading,
});
